export const AccountViewRoute = {
  route: '/me',
  title: 'navigation:titles.account',
}
